import axios from 'axios'
import {Toast} from "vant";
import store from "../store";
import router from "../router";
import process from "shelljs";
import _this from "../main";
//重试队列
let requests = []
const service = axios.create({
  baseURL: process.env.BASE_URI,
  timeout: 60000 // request timeout
})
service.interceptors.request.use(
  config => {
    const token = store.state.loginUser.sessionkey || (localStorage.getItem('giant_userdata') ? JSON.parse(localStorage.getItem('giant_userdata')).sessionkey : '')
    config.headers.Token = token
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.status == 2) {
      Toast('登录失效,即将跳转登录页')
      if(store.state.browser.giantopoapp){
        if(store.state.browser.ios){
          window.webkit.messageHandlers.back.postMessage('');
        }else{
          android.back();
        }
      }else{
        location.href = store.state.externalurl.opo;
      }
    } else if (res.status === 1) {
      return res
    }else{ // 3 和其他状态都返回登录页
      if(res.status != 2)Toast(res.msg?res.msg:'网络异常,请检查网络后重试')
      return res
    }
  },
  error => {
    Toast('网络异常,请检查网络后重试')
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js